import { ReactElement } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';

import { useUsersListQuery } from 'api';
import { GoBackButtonWithTitle, Spinner } from 'components';
import { UserStatus } from 'types';

import { CreateNotificationForm, PageHeader } from '../../components';
import { ContentW, PageW } from './styled';

export function CreateNotificationPage(): ReactElement {
  const { t } = useTranslation();
  const navigate = useNavigate();

  const { isLoading: isLoadingUsersList, usersList } = useUsersListQuery({
    status: [UserStatus.Active, UserStatus.Registered],
  });

  if (isLoadingUsersList) {
    return <Spinner />;
  }

  return (
    <PageW>
      <GoBackButtonWithTitle
        title={t('common.back')}
        onClick={() => navigate(-1)}
        containerSx={{
          marginTop: 0,
          maxWidth: '100%',
        }}
      />
      <PageHeader pageTitle={t('notifications.create.title')} />
      <ContentW>
        <CreateNotificationForm usersList={usersList} />
      </ContentW>
    </PageW>
  );
}
